module.exports = __webpack_public_path__ + "src/assets/textures/molar/spoon0_5.jpg";